import type { RichDoc } from '../rich-doc';
import type { AttachmentId, EpochMs, KnowledgeDocId, UserId, WorkspaceId } from './ids';

export const DOC_MAX_DEPTH = 10;

export interface KnowledgeDoc {
  id: KnowledgeDocId;
  workspaceId: WorkspaceId;
  parentId: KnowledgeDocId | null;
  title: string;
  bodyJson: RichDoc;
  bodyText: string;
  ownerId: UserId;
  creatorId: UserId;
  editLocked: boolean;
  shareToken: string | null;
  coverAttachmentId: AttachmentId | null;
  sortKey: string;
  archivedAt: EpochMs | null;
  createdAt: EpochMs;
  updatedAt: EpochMs;
}
